/* Tab (Oct 12 2026): renders /collections/all?color=<key> from the colour index + live product facts. */
(function(){
  var el=document.querySelector('.tab-cres'); if(!el) return;
  var m=/[?&]color=([a-z]+)/.exec(location.search); if(!m){ return; }
  var key=m[1]; var index, products, labels;
  function J(id){ var s=document.getElementById(id); return JSON.parse(s.textContent); }
  try{ index=J('tab-color-index'); products=J('tab-color-products'); labels=J('tab-color-labels'); }catch(e){ return; }
  if(!labels[key]) return;
  document.documentElement.classList.add('tab-color-mode');
  var byH={}; products.forEach(function(p){ byH[p.h]=p; });
  var list=(index[key]||[]).map(function(r){ var p=byH[r.h]; if(!p) return null;
    // Select an available size from the mapped color set and display THAT variant's price.
    var matching=(p.vs||[]).filter(function(v){return v.s===r.s;});
    var v=matching.find(function(v){return v.a;}) || matching[0];
    if(v){p=Object.assign({},p,{p:v.p,c:v.c,sale:v.sale,a:matching.some(function(z){return z.a;})});r=Object.assign({},r,{v:v.id});}
    return {p:p,r:r}; }).filter(Boolean);
  // in-stock first, keep index order otherwise
  list.sort(function(a,b){ return (b.p.a?1:0)-(a.p.a?1:0); });
  var name=labels[key];
  document.title = name + ' – Essenclo';
  el.querySelector('.tab-cres__h1').textContent = name;
  el.querySelector('.tab-cres__crumb-color').textContent = name;
  el.querySelector('.tab-cres__count').textContent = list.length + (list.length===1 ? ' style comes in ' : ' styles come in ') + name.toLowerCase() + '.';
  var chips=el.querySelector('.tab-cres__chips');
  Object.keys(labels).forEach(function(k){ var li=document.createElement('li'); var a=document.createElement('a'); a.href='/collections/all?color='+k; a.textContent=labels[k]; if(k===key) a.className='is-active'; li.appendChild(a); chips.appendChild(li); });
  var grid=el.querySelector('.tab-cres__grid');
  if(!list.length){ el.querySelector('.tab-cres__empty').hidden=false; }
  list.forEach(function(x){
    var p=x.p, r=x.r; var img=r.i ? (r.i+'?width=600') : p.img;
    var a=document.createElement('a'); a.className='tab-cres__card'; a.href=p.u+'?variant='+r.v; a.setAttribute('role','listitem');
    a.innerHTML='<span class="tab-cres__pic"><img loading="lazy" width="600" height="600" alt=""></span>'+
      '<span class="tab-cres__title"></span>'+
      '<span class="tab-cres__meta"><span class="tab-cres__price"></span>'+(p.sale?'<del class="tab-cres__was"></del>':'')+'</span>'+
      '<span class="tab-cres__set"></span>'+(p.a?'':'<span class="tab-cres__so">Sold out</span>');
    a.querySelector('img').src=img; a.querySelector('.tab-cres__title').textContent=p.t; a.querySelector('.tab-cres__price').textContent=p.p;
    if(p.sale) a.querySelector('.tab-cres__was').textContent=p.c;
    a.querySelector('.tab-cres__set').textContent = (/^Set-|^S\d/.test(r.s) ? 'In '+name.toLowerCase()+': '+r.s.replace('Set-','Set ') : r.s);
    grid.appendChild(a);
  });
  el.hidden=false;
})();
